import { useState } from "react";
import { Box, Flex } from "styled-system/jsx";
import { FormProvider } from "react-hook-form";
import { Text } from "@ttc3k/trekker";
import { OverlayPage, ConsumingOverlayPageProps } from "../OverlayPage";
import { useContactUsForm } from "./useContactUsForm";
import { useTranslation } from "react-i18next";
import { ControlledInput, ControlledTextArea } from "shared/components";

type ContactUsPageProps = ConsumingOverlayPageProps;

export const ContactUsPage = (args: ContactUsPageProps) => {
  const [formError, setFormError] = useState("");
  const { t } = useTranslation("booker", { keyPrefix: "CONTACT_PAGE" });
  const { form, onSubmit, defaultValues, loading } = useContactUsForm({
    onSuccess: () => {
      form.reset(defaultValues);
      args.onClose();
      setFormError("");
    },
    onError: m => setFormError(m),
  });

  return (
    <OverlayPage
      title={t("TITLE")}
      subtitle={t("SUBTITLE")}
      buttonLabel={t("BUTTON_LABEL")}
      onButtonClick={onSubmit}
      buttonDisabled={loading || form.formState.isSubmitting}
      {...args}
    >
      <Box mt={"400"}>
        <FormProvider {...form}>
          <form>
            <Flex flexDir={"column"} gap={"150"}>
              <ControlledInput name="firstName" label={t("FORM.FIRST_NAME")} />
              <ControlledInput name="lastName" label={t("FORM.LAST_NAME")} />
              <ControlledInput name="email" label={t("FORM.EMAIL")} />
              <ControlledInput name="phone" label={t("FORM.PHONE")} />
              <ControlledTextArea
                name="message"
                label={t("FORM.MESSAGE")}
                _focus={{
                  boxShadow: "inset 0 0 0 1px token(colors.border.dark)",
                  outline: "0",
                }}
                _hover={{
                  _focus: {
                    boxShadow: "inset 0 0 0 1px token(colors.border.dark)",
                    outline: "0",
                  },
                  _enabled: {
                    boxShadow: "inset 0 0 0 1px token(colors.border.mid)",
                    outline: "0",
                  },
                }}
              />
            </Flex>
          </form>
        </FormProvider>
      </Box>
      {formError.length > 0 && (
        <Text color={"text.error.mid"} visual={"smallMedium"}>
          {formError}
        </Text>
      )}
    </OverlayPage>
  );
};
